import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './components/App/App';

// This is the entry point of the application
const root = ReactDOM.createRoot(document.getElementById('root'));
// Renders the App component
root.render(
  <App />
);

